export default {
  trackingID: "G-S9GGGWY6V0",
};
